import { forwardRef, type ButtonHTMLAttributes } from 'react'

import styles from './Button.module.css'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost'
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className = '', variant = 'primary', ...props }, ref) => (
    <button
      ref={ref}
      className={`${styles.button} ${variant === 'secondary' ? styles.secondary : ''} ${variant === 'ghost' ? styles.ghost : ''} ${className}`}
      {...props}
    />
  )
)

Button.displayName = 'Button'
